import { Slider } from "../objects/slider";

function initHomepage() {
    $('.js-perks-slider').each(function () {
        var sliderId = '#' + $(this).attr('id');
        new Slider(sliderId);
    });
}

initHomepage();